import { ListWrapper, ListWrapperProps as WrapperProps } from "@shared/application-components"
import { PropsWithChildren } from "react"
import { useUI } from "../contexts"

export type ListWrapperProps<F> = Omit<WrapperProps<F>, "statusBar">

export const ListWrapperWithContext = <F extends unknown>({ ...props }: PropsWithChildren<ListWrapperProps<F>>) => {
  const { statusBar } = useUI()

  return <ListWrapper {...{ statusBar, ...props }} />
}
